module.exports = {"cookies":"Cookie","help":"ヘルプ","privacy":"プライバシー","signInButtonText":"Adobe ID を使用してサインイン","termsOfUse":"利用条件","updated":"更新済み"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/ja_jp.json
// module id = 948
// module chunks = 0